import { extend } from '../../../util/jquery';

export function marketsTimeSeriesTransform(data, param) {
    const frequency = param.frequency;
    if (data && data.length) {
        return data.map(item => {
            const dataObj = {
                security: item.queryKey,
                series: []
            };
            if (item.events) {
                dataObj.events = item.events;
            }
            if (!isNaN(frequency)) {
                const info = {
                    marketCloseTime: item.ticker.marketCloseTime,
                    marketOpenTime: item.ticker.marketOpenTime,
                    marketPreOpenTime: item.ticker.marketPreOpenTime,
                    marketPostTradingCloseTime:
                        item.ticker.marketPostTradingCloseTime,
                    IPODate: item.ticker.IPODate,
                    frequency: param.frequency,
                    preAfter: param.preAfter
                };

                dataObj.series = getMinutesSeries(item.series, info);
            } else {
                dataObj.series = extend(true, [], item.series);
            }

            return dataObj;
        });
    } else {
        return [];
    }
}

function getMinutesByTime(time = '') {
    const match = time.match(/(\d{2}):(\d{2}).*/);
    if (match) {
        const hour = +match[1];
        const minutes = +match[2];
        return hour * 60 + minutes;
    }
    return 0;
}

/**
 * @param {string}  dateString - string like "2021-06-29T09:20:00+08:00"
 * @returns {{date:(string), time:(string) }}
 **/
function getDateTime(dateString) {
    const dateMatch = dateString.match(
        /^((\d{4}-?\d{2}-?\d{2})T(\d{2}:\d{2}:\d{2})).*/
    );
    if (dateMatch) {
        const date = dateMatch[2];
        const time = dateMatch[3];
        return {
            date,
            time
        };
    } else {
        return {};
    }
}

function preZero(num) {
    if (num < 10) {
        return `0${num}`;
    }
    return num;
}

function convertTimeByMinutesNumber(mins) {
    return `${preZero(Math.floor(mins / 60))}:${preZero(mins % 60)}:00`;
}

function getEmptyDataPoint(date, time) {
    if (time === 1440) {
        time -= 1; // for futures, forex, we need reduce the tick of end point
    }
    const _date = getDateTime(date).date;
    const _time = convertTimeByMinutesNumber(time);
    const match = date.match(/\d{4}-?\d{2}-?\d{2}T\d{2}:\d{2}:\d{2}(.*)/);
    let timezoneInfo = '';
    if (match) {
        timezoneInfo = match[1];
    }
    return {
        date: `${_date}T${_time}${timezoneInfo}`,
        open: NaN,
        high: NaN,
        low: NaN,
        close: NaN,
        volume: NaN
    };
}

function fillEmptyDataPoint(data = [], param = {}) {
    const {
        marketCloseTime,
        marketOpenTime,
        marketPreOpenTime,
        marketPostTradingCloseTime,
        frequency,
        preAfter
    } = param;

    const openMinutes = getMinutesByTime(
        preAfter ? marketPreOpenTime : marketOpenTime
    );

    const closeMinutes = getMinutesByTime(
        preAfter ? marketPostTradingCloseTime : marketCloseTime
    );

    const timeDataMap = {};
    data.forEach(d => {
        const time = getMinutesByTime(getDateTime(d.date).time);
        timeDataMap[time] = d;
    });
    const startTime = getMinutesByTime(getDateTime(data[0].date).time);
    const endTime = getMinutesByTime(
        getDateTime(data[data.length - 1].date).time
    );
    const results = [];
    // 60 min is a special case, which start the first datapoint 30 minutes after market open instead of 60
    const startIndex = +frequency === 60 ? startTime : openMinutes;
    for (let i = startIndex; i <= closeMinutes; i = +frequency + i) {
        if (i < startTime || i > endTime) {
            results.push(getEmptyDataPoint(data[0].date, i));
        } else {
            if (timeDataMap[i]) {
                results.push(timeDataMap[i]);
            } else {
                results.push(getEmptyDataPoint(data[0].date, i));
            }
        }
    }
    return results;
}

function getMinutesSeries(series = [], param) {
    const minutesSeries = [];
    series.forEach(dailyData => {
        if (dailyData.children && dailyData.children.length) {
            dailyData.children = fillEmptyDataPoint(dailyData.children, param);
            let prevClose = dailyData.previousClose;
            let filledFirstPreClose = false;
            dailyData.children.forEach(minuteData => {
                const { open, close, high, low, volume, date } = minuteData;
                const dateMatch = date.match(
                    /^((\d{4}-?\d{2}-?\d{2})T(\d{2}:\d{2}:\d{2})).*/
                );
                if (dateMatch) {
                    const formatDate = dateMatch[1];
                    const _date = dateMatch[2];
                    // cross two or more days and include IPO date, use the close of first data point as previous close(base line)
                    if (
                        param.IPODate === _date &&
                        series.length > 1 &&
                        !isNaN(minuteData.open) &&
                        !filledFirstPreClose
                    ) {
                        prevClose = minuteData.open;
                        filledFirstPreClose = true;
                    }
                    const d = {
                        open,
                        high,
                        low,
                        close,
                        volume,
                        previousClose: prevClose,
                        originalDate: date,
                        date: formatDate
                    };
                    if (!isNaN(close)) {
                        prevClose = close;
                    }
                    minutesSeries.push(d);
                }
            });
        }
    });
    return minutesSeries;
}
